import { basketAddressFormValidatorOptions } from '@frontstoreRwd/modules/validation/form_validator/scheme/basket/form_validator_basket_scheme';
import { TFormValidatorOptions } from '@frontstoreRwd/modules/validation/form_validator/form_validator_types';

export const schemes: Record<string, TFormValidatorOptions> = {
    'basket-address': basketAddressFormValidatorOptions
};
